<template>
<div class="chapter">
<div class="inner_page">
<div id="ack">
<br/><br/><br/><br/><br/>
<p style="text-align: center;"><img alt=" " src="media/file1.png" style="width:4.02139in;height:2.7608in"/></p><br/>
<p style="text-align: center;">When the Beeman needs some shorts, to be economical he simply</p>
<p style="text-align: center;">cuts the bottom off his trousers…</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?14a969a5